// extracted by mini-css-extract-plugin
export default {"wrapperPadding":"SiteAccess_wrapperPadding__x0fWJ","log_box":"SiteAccess_log_box__802eN","modalTip":"SiteAccess_modalTip__c774n"};